module.exports = __webpack_public_path__ + "img/7.a579e016.webp";